// extracted by mini-css-extract-plugin
export default {"label":"style_label__sz1cY","value":"style_value__dZjlj","line":"style_line__j-+BQ","column":"style_column__QYkIh","address":"style_address__BnMgW"};